import React, { FunctionComponent } from 'react';
import { ScreenReaderContainer } from './ScreenReaderContainer';

export const ScreenReaderUpdateText: FunctionComponent = () => (
  <ScreenReaderContainer>
    Selecting or changing an option will update the page
  </ScreenReaderContainer>
);

export default ScreenReaderUpdateText;
